import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "services/api.service";
import { Asset } from "types/asset";

export default function useAssetExport() {
  const [isError, setIsError] = useState(false);
  const [searchParams] = useSearchParams();
  const [downloadAssetsExport, setDownloadAssetsExport] = useState<Boolean>(false);
  const [exportedAssets, setExportedAssets] = useState<any>("");

  const exportAssets = (selectAllFlag?: boolean) => {
    let args = searchParams.toString();

    if (selectAllFlag) {
      // When selectAllFlag is true, remove pagination parameters but keep all filters
      const urlParams = new URLSearchParams(args);
      urlParams.delete('page[number]');
      urlParams.delete('page[size]');
      // Keep all existing filters (including state filters)
      // Add select_all_flag to the URL query string
      urlParams.set('select_all_flag', 'true');
      args = urlParams.toString();
    }

    api
      .get<{ assets: Asset[] }>(`/assets_export.csv?${args}`)
      .then(({ data }) => {
        setExportedAssets(data);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setDownloadAssetsExport(true);
      });
  };

  return {
    isError,
    exportedAssets,
    downloadAssetsExport,
    setDownloadAssetsExport,
    exportAssets,
  };
}
